import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-colleges',
  templateUrl: './no-colleges.component.html',
  styleUrls: ['./no-colleges.component.css']
})
export class NoCollegesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
